module.exports = __webpack_public_path__ + "3b10c3d3096bc4eb737ba045bf81e3d9.MP3";